export var ECheckoutStep;
(function (ECheckoutStep) {
    ECheckoutStep[ECheckoutStep["REVIEW_CART"] = 0] = "REVIEW_CART";
    ECheckoutStep[ECheckoutStep["CHOOSE_SERVICE_TYPE"] = 1] = "CHOOSE_SERVICE_TYPE";
    ECheckoutStep[ECheckoutStep["COLLECT_ADDRESS"] = 2] = "COLLECT_ADDRESS";
    ECheckoutStep[ECheckoutStep["CHOOSE_ORDER_TIME"] = 3] = "CHOOSE_ORDER_TIME";
    ECheckoutStep[ECheckoutStep["COLLECT_PAYMENT_INFORMATION"] = 4] = "COLLECT_PAYMENT_INFORMATION";
    ECheckoutStep[ECheckoutStep["ORDER_CONFIRMATION"] = 5] = "ORDER_CONFIRMATION";
})(ECheckoutStep || (ECheckoutStep = {}));



//////////////////
// WEBPACK FOOTER
// ./src/common/analytic-events/ECheckoutStep.ts
// module id = null
// module chunks = 